module.exports = __webpack_public_path__ + "assets/0ede769c19f64a68ea22844b66f5a7ea.mp3";